export default __webpack_public_path__ + "static/media/Botão Dawnload.6f3c3170.svg";